/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BulkSelection } from './bulkSelection';
import type { UpsertReviewsRequestDecision } from './upsertReviewsRequestDecision';
import type { UpsertReviewsRequestReason } from './upsertReviewsRequestReason';

export interface UpsertReviewsRequest {
  profile_ids?: string[] | null;
  bulk?: BulkSelection | null;
  decision: UpsertReviewsRequestDecision;
  reason?: UpsertReviewsRequestReason;
  note?: string | null;
}
